import BaseApi from './baseApi';
import IListStatusOutbound from '../models/IListStatusOutbound';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusOutboundsApi extends BaseApi {
    idUser : string = "";
    idCompany: string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListStatusOutbounds() : Promise<IListStatusOutbound[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusOutbound: IListStatusOutbound[] = [];
            listStatusOutbound = response.data as IListStatusOutbound[];
            return listStatusOutbound;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListStatusOutbound(listStatusOutbound: IListStatusOutbound) : Promise<string> {
        const json = this.getJsonSave(listStatusOutbound);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListStatusOutbound(listStatusOutbound: IListStatusOutbound) : Promise<boolean> {
        const json = this.getJsonUpdate(listStatusOutbound);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListStatusOutbound(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_STATUS_OUTBOUND_IN_USE",
            "parameters": [{
                "Item1": "StatusOutboundId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusOutbounds",
                "Item2": "id"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "name"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "isFinished"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "color"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "ListStatusOutbounds"
            }],
            "conditions": [{
                "Item1": "ListStatusOutbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListStatusOutbounds.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusOutbounds",
            "conditions": [{
                "Item1": "ListStatusOutbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listStatusOutbound: IListStatusOutbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusOutbound.name
            }, {
                "Item1": "isFinished",
                "Item2": false
            }, {
                "Item1": "color",
                "Item2": listStatusOutbound.color
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusOutbounds"
        };
        return json;
    }

    private getJsonUpdate(listStatusOutbound: IListStatusOutbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusOutbound.name
            }, {
                "Item1": "isFinished",
                "Item2": listStatusOutbound.isFinished
            }, {
                "Item1": "color",
                "Item2": listStatusOutbound.color
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusOutbounds",
            "keyvalue": listStatusOutbound.id
        };
        return json;
    }
}
